import {AxiosResponse} from "axios";
import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {
  AUDIENCES_QUERY_KEY,
  RESOURCE_USAGES_QUERY_KEY,
  TEMPLATES_QUERY_KEY,
  TRIGGER_TEMPLATE_CACHE_KEYS,
} from "../queryKeys";
import {ReachTemplate, ReachTemplateCreatePayload} from "./types";

type UpdateTemplateVariables = {id: string; payload: ReachTemplateCreatePayload};

const updateTemplate = async ({id, payload}: UpdateTemplateVariables): Promise<ReachTemplate> => {
  const response = await axiosReachInstance.put<
    ReachTemplate,
    AxiosResponse<ReachTemplate>,
    ReachTemplateCreatePayload
  >(`/templates/${id}`, payload);
  return response.data;
};

export const useUpdateTemplate = (
  options?: BaseMutationOptions<ReachTemplate, UpdateTemplateVariables>
): BaseUseMutationResult<ReachTemplate, UpdateTemplateVariables> => {
  return useBaseMutation<ReachTemplate, UpdateTemplateVariables>(updateTemplate, {
    ...options,
    prefixKeysToInvalidate: () => [[TEMPLATES_QUERY_KEY]],
    prefixKeysToReset: () => [[AUDIENCES_QUERY_KEY], [RESOURCE_USAGES_QUERY_KEY], ...TRIGGER_TEMPLATE_CACHE_KEYS],
  });
};
